/* unplugin-vue-components disabled */import { render } from "./DoubleChoiceBtnGroup.vue?vue&type=template&id=5c93409a&scoped=true"
import script from "./DoubleChoiceBtnGroup.vue?vue&type=script&lang=js"
export * from "./DoubleChoiceBtnGroup.vue?vue&type=script&lang=js"

import "./DoubleChoiceBtnGroup.vue?vue&type=style&index=0&id=5c93409a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c93409a"]])

export default __exports__